import { Controller } from "@hotwired/stimulus"

// Mini help modal: trigger (e.g. ? icon) opens modal with rich text content.
// Dismiss via close button or click outside the modal content.
export default class extends Controller {
  static targets = ["modal", "modalBody", "backdrop"]

  open(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const targetId = trigger.dataset.helpTargetId
    let content = ""
    if (targetId) {
      const el = document.getElementById(targetId)
      if (el) content = el.innerHTML
    } else {
      content = trigger.dataset.helpContent || trigger.dataset.helpHtml || ""
      if (trigger.dataset.helpHtml) {
        content = content.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"")
      }
    }
    if (this.hasModalBodyTarget) {
      this.modalBodyTarget.innerHTML = content || ""
    }
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("show")
      this.positionModalNear(trigger)
    }
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("show")
    document.body.classList.add("admin-help-modal-open")
  }

  positionModalNear(trigger) {
    const pad = 8
    const rect = trigger.getBoundingClientRect()
    this.modalTarget.style.top = ""
    this.modalTarget.style.left = ""
    const modalRect = this.modalTarget.getBoundingClientRect()
    let top = rect.bottom + pad
    let left = rect.left
    if (top + modalRect.height > window.innerHeight - pad) {
      top = rect.top - modalRect.height - pad
    }
    if (top < pad) top = pad
    if (left + modalRect.width > window.innerWidth - pad) {
      left = window.innerWidth - modalRect.width - pad
    }
    if (left < pad) left = pad
    this.modalTarget.style.top = `${top}px`
    this.modalTarget.style.left = `${left}px`
  }

  close() {
    if (this.hasModalTarget) this.modalTarget.classList.remove("show")
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("show")
    document.body.classList.remove("admin-help-modal-open")
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) this.close()
  }
}
